import { NavLink } from 'react-router-dom';

import cashDepositIcon from '../../../assets/icons/cashDepositIcon.svg';
import invoiceIcon from '../../../assets/icons/invoiceIcon.svg';

type Props = {
  sidebarOpen: boolean;
  isSecondaryOpen: boolean;
};

const SecondarySideBarInvoices = ({ sidebarOpen, isSecondaryOpen }: Props) => {
  return (
    <div
      className={`fixed z-30 hidden h-full w-[58px] transition-all duration-1000 ${
        sidebarOpen ? 'ml-[212px]' : 'ml-[58px]'
      }  ${isSecondaryOpen ? 'flex flex-row ' : 'hidden'}`}
    >
      <nav className="flex w-full flex-col justify-center bg-greenextralight pt-6 text-white">
        <div className="relative my-10">
          <div className="flex items-center justify-center">
            <ul className="flex flex-col items-center gap-6">
              <li id="dashboard" className="mb-6">
                <NavLink
                  to={`/dashboard/invoices`}
                  end
                  className={({ isActive }) =>
                    isActive
                      ? 'navLinkActive flex gap-2 items-center titleAttr'
                      : 'navLinkInactive flex gap-2 titleAttr'
                  }
                  data-title="Invoices"
                >
                  <img
                    className="h-[22px]"
                    src={invoiceIcon}
                    alt="invoicesOverall"
                  />
                </NavLink>
              </li>

              <li className="mb-6">
                <NavLink
                  to={`/dashboard/invoices/cashdeposit`}
                  className={({ isActive }) =>
                    isActive
                      ? 'navLinkActive flex gap-2 items-center titleAttr'
                      : 'navLinkInactive flex gap-2 items-center titleAttr'
                  }
                  data-title="Cash Deposit"
                >
                  <img
                    className="h-[22px]"
                    src={cashDepositIcon}
                    alt="cashDeposit icon"
                  />
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default SecondarySideBarInvoices;
